import { render, staticRenderFns } from "./AppContactForm.vue?vue&type=template&id=5581590c"
import script from "./AppContactForm.vue?vue&type=script&lang=ts"
export * from "./AppContactForm.vue?vue&type=script&lang=ts"
import style0 from "./AppContactForm.vue?vue&type=style&index=0&id=5581590c&prod&module=true&lang=scss"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {AppBtn: require('/builds/project/wyffest/frontend/components/app/AppBtn.vue').default,FieldInput: require('/builds/project/wyffest/frontend/components/field/FieldInput.vue').default,FieldTextarea: require('/builds/project/wyffest/frontend/components/field/FieldTextarea.vue').default,WidgetCaptcha: require('/builds/project/wyffest/frontend/components/widget/WidgetCaptcha.vue').default,FieldCheckbox: require('/builds/project/wyffest/frontend/components/field/FieldCheckbox.vue').default})
